import gql from 'graphql-tag';

const returnInvoiceQuery = gql`
  query returnInvoice($id: ID, $productFamily: String) {
    returnInvoice(id: $id, productFamily: $productFamily) {
      id
      guaranteePurchaseId
      reinstate
      returningUser {
        username
      }
      expirationDate
      transaction {
        id
        purchasedAt
        universalNo
        expiresAt
        receiveDate
        locationName
        vin
        dealerNumber
        dealershipName
        odometer
        vehicleReceived
        titleReceived
        refundProcessed
        returnInitiatedAt
        purchasePrice
        milesSelected
        year
        make
        model
        returnLocation {
          initials
          name
        }
      }
      pendingArbitration
      selectedReasons
    }
  }
`;

export default returnInvoiceQuery;
